import { createContext, useContext } from "react";
import { Building, Building2, Home, Hotel, LandPlot, Store, Trees, Warehouse } from "lucide-react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const img = (f) => `${API}/public/listing/${f}`;
export const tl = (v) => `${new Intl.NumberFormat("tr-TR").format(v || 0)} TL`;
export const KIND = { sale: "Satılık", rent: "Kiralık" };
export const CLOSED = { sold: "Satıldı", rented: "Kiralandı" };
export const ROOMS = ["1+0", "1+1", "2+1", "3+1", "4+1", "5+"];
export const CAT_ICONS = { daire: Building2, residence: Hotel, villa: Trees, mustakil: Home, arsa: LandPlot, isyeri: Warehouse, ofis: Building, dukkan: Store };
export const CATEGORIES = { daire: "Daire", residence: "Rezidans", villa: "Villa", mustakil: "Müstakil Ev", arsa: "Arsa", isyeri: "İşyeri", ofis: "Ofis", dukkan: "Dükkan" };
export const waLink = (digits, text) => `https://wa.me/${digits}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
export const listingUrl = (l) => `${window.location.origin}/ilan/${l.slug}`;
export const listingMsg = (l) => `Merhaba, ${l.code} numaralı "${l.title}" ilanı hakkında bilgi almak istiyorum.\n${listingUrl(l)}`;
export const place = (l) => [l.neighborhood, l.district, l.city].filter(Boolean).join(", ");
export const errText = (e) => { const d = e?.response?.data?.detail; return typeof d === "string" ? d : Array.isArray(d) ? "Lütfen formdaki alanları kontrol edin" : "Bağlantı hatası, lütfen tekrar deneyin"; };

export const SiteCtx = createContext(null);
export const useSite = () => useContext(SiteCtx) || {};
